import { createRouter, createWebHashHistory } from 'vue-router'
import { sessionStorage } from '@/utils/storage'
import { generateRoutesFromMenu } from '@/utils/generateRoutes'
import { getMenuTree } from '@/api/userGroup'
import { useMenuStore } from '@/stores/menu'
import { usePermissionStore } from '@/stores/permission'
import { createPinia } from 'pinia'

const Layout = () => import('@/layout/Layout.vue')
// 白名单路由
const whiteList = ['/login']
// 判断是否是刷新页面进入的守卫
let isRefresh = false
export const constantRoutes = [
  // {
  //   path: '/',
  //   redirect: '/BasicManage/SchoolManage/List',
  //   meta: { hidden: true }
  // },
  {
    path: '/login',
    name: 'login',
    meta: { hidden: true },
    component: () => import('../pages/Login/Pages/index.vue'),
  },
  {
    path: '/ZZZTEST',
    name: 'ZZZTEST',
    meta: { hidden: true },
    component: () => import('../pages/ZZZTEST/index.vue'),
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRoutes,
  // 刷新时，滚动条位置还原
  scrollBehavior: () => ({ left: 0, top: 0 }),
})

// 是否已添加动态路由
let hasAddedRoutes = false

// 路由守卫
router.beforeEach(async (to, from, next) => {
  const info = sessionStorage.get('userInfo')
  const needResetPwd = info?.needResetPwd

  const token = sessionStorage.get('token'+info?.id)
  const dialogShow = sessionStorage.get('dialogShow')
  console.log('路由守卫', token)
  // 修改判断逻辑
  if (token) {
    // 如果需要重置密码或对话框正在显示，强制停留在登录页
    if (needResetPwd === 1 || dialogShow === 'true') {
      if (to.path !== '/login') {
        next('/login')
      } else {
        next()
      }
      return
    }

    // 正常登录后的路由处理
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if (!hasAddedRoutes) {
        try {
          isRefresh = true
          const menuData = await getMenuTree()
          const menuStore = useMenuStore()
          const permissionStore = usePermissionStore()
          
          menuStore.setMenuList(menuData)
          permissionStore.setMenuList(menuData)
          
          // 设置当前页面的按钮权限
          permissionStore.setCurrentPagePermissions(to.path)
          
          const routes = generateRoutesFromMenu(menuData)
          
          // 添加动态路由
          for (const route of routes) {
            router.addRoute(route)
          }
          console.log('routes', routes)
          hasAddedRoutes = true
          
          if (to.path === '/') {
            // 添加安全校验防止访问未定义属性
            const defaultRoute = routes[0]
            const childPath = defaultRoute?.children?.[0]?.path
            const childPath2 = defaultRoute?.children?.[0]?.children?.[0]?.path
            if(childPath2){
              // 使用模板字符串提高可读性
              next({ 
                path: `${defaultRoute.path}/${childPath}/${childPath2}`,
                replace: true 
              })
            }else{
              next({ 
                path: `${defaultRoute.path}/${childPath}`,
                replace: true 
              })
            }
          } else {
            next({ ...to, replace: true })
          }
        } catch (error) {
          console.error('加载动态路由失败:', error)
          next('/login')
        }
      } else {
        // 路由变化时更新当前页面的按钮权限
        const permissionStore = usePermissionStore()
        permissionStore.setCurrentPagePermissions(to.path)
        if (to.path === '/') {
          next({ path: '/BasicManage/SchoolManage/List' })
        } else {
          next()
        }
      }
    }
  } else {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/login')
    }
  }
})

// 添加重置路由的方法
export const resetRouter = () => {
  // 移除所有动态添加的路由
  const removeRoutes = router.getRoutes()
  removeRoutes.forEach(route => {
    if (route.name) {
      router.removeRoute(route.name)
    }
  })
  
  // 重新添加固定路由
  constantRoutes.forEach(route => {
    router.addRoute(route)
  })
  
  // 重置路由添加状态
  hasAddedRoutes = false
}

/**
 * 重新拉取当前用户菜单并热更新动态路由（菜单增删改后调用，无需整页刷新）
 */
export async function refreshDynamicRoutes(currentPath?: string) {
  const menuData = await getMenuTree()
  const menuStore = useMenuStore()
  const permissionStore = usePermissionStore()
  const fullPath = router.currentRoute.value.fullPath

  resetRouter()

  const routes = generateRoutesFromMenu(menuData)
  for (const route of routes) {
    router.addRoute(route)
  }
  hasAddedRoutes = true

  // 最后更新 store，便于 Layout 等监听方基于最新路由重建菜单
  menuStore.setMenuList(menuData)
  permissionStore.setMenuList(menuData)
  if (currentPath) {
    permissionStore.setCurrentPagePermissions(currentPath)
  }

  // 重新匹配当前地址，避免重置路由后页面状态异常
  await router.replace(fullPath)

  return routes
}

export default router